import { useEffect } from 'react';
import { ReactComponent as CloseIcon } from 'images/icons/close.svg';
import { ReactComponent as PhoneIcon } from 'images/icons/phone_small.svg';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function PhoneDetails({
  phoneNumber,
  openingHours,
  closePhoneDetails,
}) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  const handleClose = () => {
    document.body.style.overflow = 'unset';
    closePhoneDetails();
  };

  return (
    <div className="bg-white w-screen h-screen fixed top-0 left-0 bottom-0 overflow-hidden z-[200]">
      <div className="flex justify-end h-[77px] border-solid border-b-[1px] border-b-[#f0f0f0]">
        <button type="button" onClick={handleClose} className="mr-5">
          <CloseIcon />
        </button>
      </div>
      <div
        style={{
          borderColor: DEFAULT_PRIMARY_COLOUR,
          color: DEFAULT_PRIMARY_COLOUR,
        }}
        className="flex flex-col items-center mt-8 justify-center"
      >
        <a
          href={`tel:${phoneNumber}`}
          className="w-[335px] h-[50px] border-solid rounded-full border-2 border-[#072636] flex justify-center items-center font-medium"
        >
          <PhoneIcon />
          <p className="ml-2 text-[15px]">{phoneNumber}</p>
        </a>
        <p className="mt-2.5 text-[15px] font-medium">{openingHours}</p>
      </div>
    </div>
  );
}
